import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Checkbox, Grid, TextField, Button,  Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
import { KeyboardDatePicker } from '@material-ui/pickers';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { getTomorrowDate } from '../../utils/dates';
import { useMutation } from 'react-query';
import { deleteTodo, updateTodo } from '../../api/objective/todo.api';
import { addAlert } from '../../actions/alerts.action';
import { STATUS } from '../../utils/const';

const useStyles = makeStyles(theme => ({
  root: {
    color: '#666666',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      borderBottom: '1px solid #F1F1F1'
    }
  },
  binIcon: {
    color: '#666666',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '100px'
    }
  },
  checkbox: {
    color: '#666666',
    marginLeft: '-20px'
  },
  nameInput: {
    color: '#666666',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '30px'
    }
  },
  row: {
    display: 'flex',
    flexDirection: 'row'
  },
  datePicker: {
    minWidth: '170px'
  }
}));

const DialogTodoItem = ({ objectiveId, todoToUpdate, onSubmitSuccess, status }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [ name, setName ] = useState(todoToUpdate.name);
  const [ validation, setValidation ] = useState({
    name: todoToUpdate.name.length !== 0,
    deadline: !todoToUpdate.deadline || !isNaN(Date.parse(todoToUpdate.deadline))
  });

  const updateTodoMutation = useMutation(
    async todo => {
      return await updateTodo({ objectiveId, todo });
    },
    {
      onSuccess: () => {
        onSubmitSuccess();
      },
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );

  const deleteTodoMutation = useMutation(
    async () => {
      return await deleteTodo({
        objectiveId,
        todoId: todoToUpdate.id
      });
    },
    {
      onSuccess: () => {
        onSubmitSuccess();
      },
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );

  const handleIsDoneChange = event => {
    updateTodoMutation.mutate({
      ...todoToUpdate,
      is_done: event.target.checked
    });
  };

  const handleOnChangeName = event => {
    const isNameValid = event.target.value.length !== 0;

    setValidation({
      ...validation,
      name: isNameValid
    });

    setName(event.target.value);
  };

  const handleNameBlur = () => {
    if (validation.name && name !== todoToUpdate.name) {
      updateTodoMutation.mutate({
        ...todoToUpdate,
        name
      });
    }
  };

  const handleDeadlineChange = date => {
    const isDateValid = !date || !isNaN(Date.parse(date));

    setValidation({
      ...validation,
      deadline: isDateValid
    });

    if (isDateValid) {
      updateTodoMutation.mutate({
        ...todoToUpdate,
        deadline: date
      });
    }
  };

  return (
    <Grid container spacing={ 2 } className={ classes.root }>
      <Grid item xs={ 6 } className={  classes.row }>
        <Grid item xs={ 1 }>
          <Tooltip
            disableHoverListener={ STATUS.ACTIVE === status }
            title={ t(`objective.todos.error.statusError`) }>
            <span>
              <Checkbox
                className={  classes.checkbox }
                checked={ todoToUpdate.is_done }
                onChange={ handleIsDoneChange }
                inputProps={ { 'aria-label': 'primary checkbox' } }
                disabled={ STATUS.ACTIVE !== status }
              />
            </span>
          </Tooltip>
        </Grid>
        <Grid item xs={ 11 }>
          <TextField
            onBlur={ handleNameBlur }
            value={ name }
            error={ !validation.name }
            helperText={ !validation.name ? 'objective.todos.create.name.error' : '' }
            className={ classes.nameInput }
            onChange={ handleOnChangeName }
            fullWidth
            placeholder={ t('objective.todos.create.name.placeholder') }
          />
        </Grid>
      </Grid>
      <Grid item xs={ 6 } className={  classes.row }>
        <Grid item xs={ 7 }>
          <KeyboardDatePicker
            className = { classes.datePicker }
            value={ todoToUpdate.deadline }
            error={ !validation.deadline }
            helperText={ !validation.deadline ?
              t('objective.todos.create.deadline.error') : '' }
            autoOk={ true }
            disableToolbar
            variant="inline"
            format="yyyy/MM/dd"
            onChange={ handleDeadlineChange }
            minDate={ getTomorrowDate() }
            KeyboardButtonProps={ {
              'aria-label': 'change date',
              position: 'start'

            } }
            keyboardIcon={
              <DateRangeOutlinedIcon />
            }
          />
        </Grid>
        <Grid item xs={ 5 }>
          <Button
            onClick={ deleteTodoMutation.mutate }
          >
            <DeleteOutlineIcon className={ classes.binIcon }/>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DialogTodoItem;
